import { SellerResponseOnBidForm } from "../../components/seller/SellerResponseOnBidForm";

import React from "react";
import Grid from '@mui/material/Grid';
import { useParams } from "react-router-dom";
import { AuthHelper } from '../../utils/auth_helper';


function SellerResponseOnBid() {

  let { bidByEmpId } = useParams();
  // console.log('---SellerResponseOnBid---bidByEmpId:', bidByEmpId)


  return (
    <div>
      <AuthHelper />

      <div className="tw-px-5 sm:tw-ml-20 tw-text-left">

        <Grid container direction="row" alignItems="center" justifyContent="" >

          <Grid container>
            <Grid item xs={12} sm={12}>
              <span className="tw-p-10 tw-text-3xl"><p>Respond on Bid</p></span>
            </Grid>
          </Grid>

          <SellerResponseOnBidForm bidByEmpId={bidByEmpId} />

        </Grid>

      </div>

    </div>
  );

}


export { SellerResponseOnBid };
